import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseToggleSwitchComponent } from "../../../ui-kit/inputs/base-toggle-switch/base-toggle-switch.component";

@Component({
  selector: 'app-toggle-row',
  standalone: true,
  imports: [BaseToggleSwitchComponent],
  templateUrl: './toggle-row.component.html',
  styleUrl: './toggle-row.component.scss'
})
export class ToggleRowComponent {
  @Input() setting: any;
  @Input() description: string;
  @Input() settingVariant: string = '';
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Output() settingChange = new EventEmitter;


  onToggle() {
    const changes = {
      setting: this.setting, // Key
      variant: this.settingVariant, // Usage / pref
      value: !this.checked,
    }
    this.settingChange.emit(changes);
  }
}
